import { Link } from 'react-router-dom';
import { Logo } from '../components/Layout';
import '../styles/compte.css';

const STEPS = [
  {
    title: 'Dépôt en ligne ou au guichet',
    text: 'Vous renseignez votre identité et transmettez les pièces demandées. Un agent peut vous accompagner.',
  },
  {
    title: 'Identité et recevabilité',
    text: 'Le service vérifie votre identité et la recevabilité de la demande. Un complément peut vous être demandé.',
  },
  {
    title: 'Recherche et règles',
    text: 'Les sources sont consultées et les règles approuvées sont appliquées. Si les archives ne suffisent pas, une recherche complémentaire est menée.',
  },
  {
    title: 'Validation et signature',
    text: 'L’autorité compétente valide et signe le document. Aucune délivrance automatique.',
  },
  {
    title: 'Remise et vérification',
    text: 'Le document est mis à disposition dans votre espace sécurisé. Il porte un code permettant d’en vérifier l’authenticité.',
  },
];

const PRINCIPLES = [
  {
    title: 'Aucune conclusion hâtive',
    text: 'Une absence de résultat dans une base partiellement reprise ne vaut jamais absence de mention.',
  },
  {
    title: 'Décision humaine',
    text: 'Les outils numériques préparent et contrôlent ; les autorités habilitées décident.',
  },
  {
    title: 'Accès proportionné',
    text: 'Chaque agent n’accède qu’à ce que sa mission, son ressort et la finalité justifient. Tout accès est tracé.',
  },
  {
    title: 'Discrétion',
    text: 'Les SMS et courriels annoncent une étape, jamais une condamnation ou une peine.',
  },
];

export function HomePage() {
  return (
    <>
      <section className="hero" aria-labelledby="titre-accueil">
        <p className="eyebrow rise">République gabonaise · Ministère de la Justice</p>
        <h1 id="titre-accueil" className="rise">
          Le casier judiciaire.
          <br />
          <span>Fiable et accessible.</span>
        </h1>
        <p className="lead rise2">
          Demandez votre bulletin en ligne ou au guichet, suivez son avancement et vérifiez l’authenticité de
          chaque document.
        </p>
        <div className="actions rise2">
          <Link className="btn" to="/connexion">
            Demander un bulletin
          </Link>
          <Link className="lnk" to="/demarches">
            Comprendre la démarche ›
          </Link>
        </div>
        <div className="hero-logo rise3">
          <Logo width="72%" label="Logo CASIJUD : balance de la justice" />
        </div>
      </section>

      <section className="home-section" aria-labelledby="titre-etapes">
        <h2 id="titre-etapes" className="section-title">
          Cinq étapes.
          <br />
          <span>Une décision toujours humaine.</span>
        </h2>
        <div className="steps">
          {STEPS.map((s, i) => (
            <div key={s.title}>
              <span className="step-num" aria-hidden="true">
                {i + 1}
              </span>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="home-section" style={{ paddingTop: 0 }} aria-label="Services publics">
        <div className="duo">
          <div className="card tint">
            <h2>Vérifier un document.</h2>
            <p className="muted">
              Code du QR ou fichier PDF. La réponse dit seulement s’il est authentique ou révoqué.
            </p>
            <Link className="btn btn-sm" to="/verifier">
              Vérifier
            </Link>
          </div>
          <div className="card tint">
            <h2>Suivre une demande.</h2>
            <p className="muted">
              Référence et code de suivi suffisent. Aucune donnée personnelle n’est affichée.
            </p>
            <Link className="btn btn-ghost btn-sm" to="/suivi">
              Voir l’état
            </Link>
          </div>
        </div>
      </section>

      <section className="band" aria-labelledby="titre-principes">
        <div>
          <h2 id="titre-principes" className="section-title">
            Nos engagements.
          </h2>
          <div className="steps">
            {PRINCIPLES.map((p) => (
              <div key={p.title} style={{ borderTop: 'none', paddingTop: 0 }}>
                <h3>{p.title}</h3>
                <p>{p.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

function InfoIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5M12 8h.01" />
    </svg>
  );
}

export function DemarchesPage() {
  return (
    <div className="dem">
      <div className="head rise">
        <div>
          <h1>Démarches</h1>
          <p className="lead">
            Qui peut demander un bulletin, par quels canaux, et comment se règlent les droits.
          </p>
        </div>
      </div>
      <div className="cols dem-cols">
        <section className="card" aria-labelledby="dem-qui">
          <span className="num" aria-hidden="true">
            1
          </span>
          <h2 id="dem-qui">Qui peut demander quoi ?</h2>
          <p>
            Le casier judiciaire distingue plusieurs bulletins. Certains ne sont délivrés qu’à des autorités
            ou à des organismes habilités, pour une finalité déterminée ; d’autres peuvent être demandés par
            la personne concernée. Les conditions exactes relèvent des textes applicables et du référentiel
            validé.
          </p>
        </section>
        <section className="card" aria-labelledby="dem-canaux">
          <span className="num" aria-hidden="true">
            2
          </span>
          <h2 id="dem-canaux">Les canaux</h2>
          <ul>
            <li>En ligne, depuis un téléphone, une tablette ou un ordinateur.</li>
            <li>Au guichet, avec l’accompagnement d’un agent - un récépissé vous est remis.</li>
            <li>
              Depuis l’étranger, selon les modalités qui seront définies avec les institutions compétentes.
            </li>
          </ul>
        </section>
        <section className="card" aria-labelledby="dem-paiement">
          <span className="num" aria-hidden="true">
            3
          </span>
          <h2 id="dem-paiement">Paiement des droits</h2>
          <p>
            Lorsque des droits sont exigibles, ils sont réglés par timbre fiscal numérique auprès des canaux
            autorisés. Les tarifs et les exonérations seront publiés après approbation.
          </p>
        </section>
        <section className="card" aria-labelledby="dem-erreur">
          <span className="num" aria-hidden="true">
            4
          </span>
          <h2 id="dem-erreur">Signaler une erreur</h2>
          <p>
            Vous pourrez signaler une erreur depuis votre espace. Le signalement ne modifie pas directement
            une inscription : il est instruit selon la procédure de rectification prévue par la loi.
          </p>
        </section>
      </div>
      <section className="card tint dem-cta" aria-labelledby="dem-pret">
        <h2 id="dem-pret">Prêt à faire votre demande ?</h2>
        <div className="actions">
          <Link className="btn" to="/connexion">
            Demander un bulletin
          </Link>
          <Link className="btn btn-ghost" to="/suivi">
            Suivre une demande
          </Link>
        </div>
      </section>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <div className="card notfound">
      <span className="tile-icon lg" aria-hidden="true">
        <InfoIcon />
      </span>
      <h1>Page introuvable</h1>
      <p>
        <Link className="lnk" to="/">
          Revenir à l’accueil
        </Link>
      </p>
    </div>
  );
}
